import { c as _c } from "react/compiler-runtime";
import { cva } from 'class-variance-authority';
const customButtonStyles = cva('transition-colors underline underline-offset-2 cursor-pointer disabled:opacity-70', {
  variants: {
    disabled: {
      true: 'cursor-default',
      false: ''
    },
    editMode: {
      true: 'text-error hover:text-error-hover',
      false: 'text-accent hover:text-accent-hover'
    }
  },
  defaultVariants: {
    disabled: false,
    editMode: false
  }
});
interface CustomButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  disabled: boolean;
  isAssumedSessionEditMode: boolean;
}
export const CustomButton = t0 => {
  const $ = _c(7);
  const {
    children,
    onClick,
    disabled,
    isAssumedSessionEditMode
  } = t0;
  let t1;
  if ($[0] !== disabled || $[1] !== isAssumedSessionEditMode) {
    t1 = customButtonStyles({
      disabled,
      editMode: isAssumedSessionEditMode
    });
    $[0] = disabled;
    $[1] = isAssumedSessionEditMode;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== onClick || $[5] !== t1) {
    t2 = <button type="button" onClick={onClick} className={t1}>{children}</button>;
    $[3] = children;
    $[4] = onClick;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default CustomButton;